import { reactive, watch, computed } from 'vue'
import { stateOptions } from '~/utils/states'

export interface FilterOptions {
  role?: string
  role_id?: string
  roleName?: string
  state?: string
  city?: string
  originalCityFormat?: string
}
export default function useFilters(
  initialFiltersRef: Ref<any>,
  permalinkRef?: Ref<string>,
  options?: { forReviews?: boolean }
) {
  const filters = reactive<FilterOptions>({
    role: initialFiltersRef.value?.role || '',
    role_id: initialFiltersRef.value?.role_id || '',
    roleName: initialFiltersRef.value?.roleName || '',
    state: initialFiltersRef.value?.state || '',
    city: initialFiltersRef.value?.city || '',
    originalCityFormat: initialFiltersRef.value?.originalCityFormat || ''
  })
  const stateFullName = computed(() => {
    if (!filters.state) return ''
    const stateOption = stateOptions.find(
      option => option.code === filters.state
    )
    return stateOption ? stateOption.label : ''
  })
  const locationDisplay = computed(() => {
    if (filters.city && filters.state) {
      return `${filters.city}, ${filters.state.toUpperCase()}`
    }
    if (filters.city) {
      return filters.city
    }
    if (filters.state) {
      return stateFullName.value
    }
    return ''
  })
  const handleFilterUpdate = (newFilters: any) => {
    if (options?.forReviews && newFilters.role) {
      filters.role = newFilters.role.title || ''
      filters.role_id = newFilters.role.soc_code_id || ''
      filters.roleName = newFilters.role.title || ''
    } else if (newFilters.role) {
      filters.role = newFilters.role?.title || ''
      filters.role_id = ''
    } else {
      filters.role = newFilters.roleName || newFilters.role || ''
      filters.role_id = newFilters.role_id || ''
      filters.roleName = newFilters.roleName || ''
    }
    filters.state = newFilters.state || ''
    filters.city = newFilters.city || ''
    filters.originalCityFormat = newFilters.originalCityFormat || ''
  }
  if (permalinkRef) {
    watch(permalinkRef, (newPermalink, oldPermalink) => {
      if (newPermalink !== oldPermalink) {
        filters.role = initialFiltersRef.value?.role || ''
        filters.role_id = initialFiltersRef.value?.role_id || ''
        filters.roleName = initialFiltersRef.value?.roleName || ''
        filters.state = initialFiltersRef.value?.state || ''
        filters.city = initialFiltersRef.value?.city || ''
        filters.originalCityFormat
          = initialFiltersRef.value?.originalCityFormat || ''
      }
    })
  }
  watch(
    initialFiltersRef,
    (newFilters) => {
      if (newFilters) {
        filters.role = newFilters.role || ''
        filters.role_id = newFilters.role_id || ''
        filters.roleName = newFilters.roleName || ''
        filters.state = newFilters.state || ''
        filters.city = newFilters.city || ''
        filters.originalCityFormat = newFilters.originalCityFormat || ''
      }
    },
    { deep: true }
  )
  return {
    filters,
    stateFullName,
    locationDisplay,
    handleFilterUpdate
  }
}
